import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';

const Auth = () => {

  const navigate = useNavigate();

  const auth = useSelector((state) => state.AuthReducer);

  useEffect(() => {
    if (!localStorage.getItem('accessToken')) {
      navigate('/');
    }
  }, [auth]);

  if (!auth) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="spinner"></div>
      </div>
    );
  }

  return <Outlet />
}

export default Auth;